
require([
    // Application.
    "app",

    // Main Router.
    "router",

    "backbone"
  ],

  function(app, Router, Backbone) {

    //Creting main Layout
    window.BticinoS4B.Instances.Views.Layout = new Backbone.Layout({
      el: "#main"
    });

    // Define your master router on the application namespace and trigger all
    // navigation from this instance.
    window.BticinoS4B.Instances.Router = new Router();

    // Trigger the initial route and enable HTML5 History API support, set the
    // root folder to '/' by default.  Change in app.js.
    Backbone.history.start({
      pushState: true,
      root: app.root
    });

    // All navigation that is relative should be passed through the navigate
    // method, to be processed by the router. If the link has a `data-bypass`
    // attribute, bypass the delegation completely.

    $(document).on("click", "a:not([data-bypass])", function(evt) {
      // Get the absolute anchor href.
      var href = $(this).prop("href");
      // Get the absolute root.
      var root = location.protocol + "//" + location.host + app.root;
      window.BticinoS4B.root = root;

      // Ensure the protocol is not part of URL, meaning it's relative.

      // Stop the default event to ensure the link will not cause a page
      // refresh.
      evt.preventDefault();

      // `Backbone.history.navigate` is sufficient for all Routers and will
      // trigger the correct events. The Router's internal `navigate` method
      // calls this anyways.  The fragment is sliced from the root.
      Backbone.history.navigate(href.slice(root.length), true);

    });
  });
define("main", function(){});
